module.exports = __webpack_public_path__ + "static/media/MHRP13N0001.438dac36.svg";